module.exports = __webpack_public_path__ + "static/media/entrepreneurial-platform-banner1.f4541e23.png";